import { render, staticRenderFns } from "./CourseGeneral.vue?vue&type=template&id=42ae53fa&scoped=true"
import script from "./CourseGeneral.vue?vue&type=script&lang=js"
export * from "./CourseGeneral.vue?vue&type=script&lang=js"
import style0 from "./CourseGeneral.vue?vue&type=style&index=0&id=42ae53fa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ae53fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42ae53fa')) {
      api.createRecord('42ae53fa', component.options)
    } else {
      api.reload('42ae53fa', component.options)
    }
    module.hot.accept("./CourseGeneral.vue?vue&type=template&id=42ae53fa&scoped=true", function () {
      api.rerender('42ae53fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CourseGeneral.vue"
export default component.exports